import React from 'react';
import { motion } from 'framer-motion';

const Marquee = () => {
  const text = "Ca' del Sole Italia • Borgo Medievale • Montagnana • ";
  const repeatedText = text.repeat(10);

  return (
    <div className="relative overflow-hidden bg-[#D4AF37] py-6 border-y border-[#2A2520]/10">
      <motion.div
        animate={{ x: [0, -1000] }}
        transition={{
          duration: 30,
          repeat: Infinity,
          ease: 'linear',
        }}
        className="whitespace-nowrap"
      >
        <span className="text-4xl md:text-5xl font-serif text-[#2A2520] tracking-wider">
          {repeatedText}
        </span>
      </motion.div>
    </div>
  );
};

export default Marquee;
